import { isNil } from 'src/utils/utils';

export const stationName = (stationId: any, stations: any[]) => {
  const currentStation = stations.find(
    station => station.stationId + '' === stationId + ''
  );

  if (!isNil(currentStation)) {
    return currentStation.overwriteStationName + '';
  } else {
    return '...';
  }
};

export const parameterClass = (parameter: string): string => {
  const coloredTemperatureParameters = [
    'tt',
    'road_rst',
    'road_rst_max',
    'road_rst_min',
    'bridge_rst',
    'bridge_rst_max',
    'bridge_rst_min',
    'bike_rst',
    'bike_rst_max',
    'bike_rst_min',
    'foot_rst',
    'foot_rst_max',
    'foot_rst_min',
    'tx',
    'tn',
    'rail_tt',
    'rail_tx',
    'rail_tn',
    'overhead_tt',
    'overhead_tx',
    'overhead_tn',
    'wing_rst',
  ];
  if (
    coloredTemperatureParameters.indexOf(parameter) >= 0 ||
    parameter.indexOf('_rst_') > 0
  ) {
    return 'tt_color';
  } else if (
    parameter.indexOf('tt') >= 0 ||
    parameter.indexOf('tg') >= 0 ||
    parameter === 'td'
  ) {
    return 'tt';
  }
  if (parameter.indexOf('i_') === 0 || parameter.indexOf('road_i_') === 0) {
    return 'index';
  }
  // parameter === 'wwc' || parameter === 'wwp' || parameter === 'wwt'
  const possibilityParameters = ['wwc', 'wwp', 'wwt', 'wws'];
  if (possibilityParameters.indexOf(parameter) >= 0) {
    return 'possibility';
  }
  // condition
  const conditionParameters = [
    'road_rsc',
    'bridge_rsc',
    'bike_rsc',
    'foot_rsc',
    'rail_condition',
    'overhead_condition',
    'wing_rsc',
  ];
  if (conditionParameters.indexOf(parameter) >= 0) {
    return 'condition';
  }
  return '';
};

export const checkRegionForParameterset = (
  region: string,
  windpowerMode: boolean,
  solarpowerMode: boolean
): boolean => {
  if (windpowerMode && region.indexOf('Wind') < 0) return false;
  if (solarpowerMode && region.indexOf('Solar') < 0) return false;
  return true;
};
